export default __webpack_public_path__ + "static/media/fingerprint.bf8078c6.svg";